
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.216 16c.19 0 .372-.033.549-.098.176-.065.366-.157.568-.274l10.873-6.304c.399-.223.68-.43.843-.623.163-.193.245-.426.245-.701 0-.268-.082-.5-.245-.696-.163-.196-.444-.405-.843-.628L2.333.373a3.716 3.716 0 00-.568-.275A1.568 1.568 0 001.215 0C.85 0 .556.127.334.382.111.637 0 .984 0 1.422v13.156c0 .438.111.785.333 1.04.223.255.517.382.883.382zm.588-2.059c-.059 0-.088-.036-.088-.108V2.167c0-.072.03-.108.088-.108.033 0 .072.013.118.039L11.95 7.902a.134.134 0 01.064.034.086.086 0 01.024.064.086.086 0 01-.024.064.243.243 0 01-.064.044l-10.03 5.804a.309.309 0 01-.117.03z","fill":"#AAB4C0"}})])
          )
        }
      }
    